import { Controller } from "stimulus"

// Shows a newsletter post's author as one line of text ("By Margot Keller · Change") and swaps in
// the author select only while it's being changed. The select stays in the form the whole time, so
// the submitted post[author_id] and auto-save (which watches the select) work as before.
export default class AuthorController extends Controller {
  static targets = ["summary", "name", "toggle", "field", "select"]

  edit() {
    this.summaryTarget.classList.add("hidden")
    this.fieldTarget.classList.remove("hidden")
    this.selectTarget.focus()
  }

  pick() {
    const option = this.selectTarget.selectedOptions[0]
    const chosen = Boolean(this.selectTarget.value)

    this.nameTarget.textContent = chosen ? `By ${option.text}` : "No author"
    this.toggleTarget.textContent = chosen ? "Change" : "Add"
    this.close()
  }

  close() {
    this.fieldTarget.classList.add("hidden")
    this.summaryTarget.classList.remove("hidden")
  }

  closeOnEscape(event) {
    if (event.key !== "Escape") return

    event.preventDefault()
    this.close()
    this.toggleTarget.focus()
  }
}
